import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GipReqManForm } from 'src/app/workflow/request/request.model';
import { FormularService } from 'src/app/Services/formular.service';
import { ActivatedRoute, Router } from '@angular/router';
import { postGipReqMan } from 'src/app/workflow/request/request.model';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';

@Component({
  selector: 'app-gipReqManFwdForm',
  templateUrl: './gipReqManFwdForm.component.html',
  styleUrls: ['./gipReqManFwdForm.component.css']
})
export class GipReqManFwdFormComponent implements OnInit {
  constructor(
    private shareData: SharingDataService,
    public formularService: FormularService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private errorHandlingService: ErrorHandlingService,
  ) { }

  resourceDefinition;
  language;

  GipReqManFwdForm = GipReqManForm;
  postGipReqMan = postGipReqMan;
  id;
  g3e_fid;
  isEdit: boolean;

  formular = [
    { formControlName: "G3E_FID",     editReadonly : true,   newReadonly: true,   readonly: true,   inputString: true, title: "cptn_forwardTo"},
    { formControlName: "RQTITLE",     editReadonly : true,   newReadonly: true,   readonly: true,   hidden: true,  inputString: true, title: null, newRow: true},
    { formControlName: "PERSON_FWD",  editReadonly : false,   newReadonly: true,   readonly: true,   required: true, modalWindow: true, function: "personIdModalWindow", newRow: true},
    { formControlName: "FULLNAME",    editReadonly : true,   newReadonly: true,   readonly: true,   inputString: true, newRow: true},
    { formControlName: "INTNOTE",     editReadonly : false,   newReadonly: true,   readonly: true,   textArea: true, title: "cptn_internalComFwd"},
    { formControlName: "btn_forward",   function: "forward", button: true, type:"submit", newRow: true,},
    { formControlName: "btn_back",      function: "back", button: true, type:"button",},
 ];

  action(action){
    this[action]();
  }

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentLanguage.subscribe(data => this.language = data);
    this.getUrlParams();
  }

  getUrlParams(){
    this.route.queryParams
    .subscribe(params => {
      if(params.g3e_fid != undefined){
        this.g3e_fid = params.g3e_fid;
        this.setReadonly();
      }
      if(params.isEdit != ""){
        this.isEdit = params.isEdit;
        this.setReadonly();
      }
      if(params.g3e_fid == undefined){
        this.changeToNew();
      }
    });
  }

  setReadonly(){
    if(!this.isEdit && this.isEdit == undefined){
      this.changeToDisplay();
    } else if (this.isEdit) {
      this.changeToEdit();
    }
    this.getData();
  }


  changeToEdit(){
    this.formular.forEach(element => {
      if(element.editReadonly){
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
  }

  changeToDisplay(){
    this.formular.forEach(element => {
      element.readonly = true;
    });
  }

  changeToNew(){
    this.formular.forEach(element => {
      if(element.newReadonly){
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
  }

  personIdModalWindow(){
    const dialogRef = this.dialog.open(personFwdDialog, {
      data: {email: this.GipReqManFwdForm.value.PERSON_FWD}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        console.log(result);
        var selectedRow = result;
        this.GipReqManFwdForm.controls.FULLNAME.setValue(selectedRow.FULLNAME);
        this.GipReqManFwdForm.controls.PERSON_FWD.setValue(selectedRow.EMAIL);
      }
    });
  }

  back(){
    this.router.navigate(["/gipReqManForm"], { queryParams: { g3e_fid: this.g3e_fid }});
  }

  forward(){
    console.log(this.GipReqManFwdForm);
    if(this.GipReqManFwdForm.status == "VALID"){
      for(let formElement in this.GipReqManFwdForm.controls){
        for(let postElement in this.postGipReqMan){
          if(postElement == formElement){
            this.postGipReqMan[postElement] = this.GipReqManFwdForm.value[formElement];
          }
        }
      }
      this.formularService.postData(`plot/forwardplot/${this.language}`, this.postGipReqMan, (data) => {
        this.errorHandlingService.showSuccess(undefined, undefined);
        this.back();
      });
      console.log(this.postGipReqMan)

    } else {
      this.GipReqManFwdForm.controls.PERSON_FWD.setErrors({required: true})
    }
  }

  getData() {
    let urls = [
      `Data/MS_REQ_N?$filter=G3E_FID eq ${this.g3e_fid}`,
    ];
    var data = this.formularService.getData(urls, (data) => {
      if (data[0][0] != undefined) {
        for (var dataElement in data[0][0]) {
          for (var value in this.GipReqManFwdForm.value) {
            if (dataElement == value) {
              this.GipReqManFwdForm.controls[value].setValue(data[0][0][dataElement])
            }
          }
        }
      }
    });
  }

}


@Component({
  selector: 'personFwdDialog',
  templateUrl: 'personFwdDialog.html',
})
export class personFwdDialog {
  resourceDefinition;
  email;
  PersonIDGrid;
  selectedRows;
  defaultFilter = "ROLES in ('IN_USR','IN_ADM')"
  urlString = "admin/V_MS_USER"
  defaultOrderby = [["SURNAME"],["up"]];
  selectedKey="USERGUID";
  groupName="V_MS_USER";

  PersonID = [
    {name: "select",        visible: true,   enableFilter: false, enableOrderBy: false,   export : false,   type : "singleSelect",  enableSelect: true,   columnSearch : false,  fromToFilter : false,   picklistTableName : null,         function : "Select",  CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
    {name: "USERGUID",      visible: false,  enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,         function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
    {name: "TITLE",         visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,         function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
    {name: "NAME",          visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,         function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
    {name: "SURNAME",       visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,         function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
    {name: "FULLNAME",      visible: false,  enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,         function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
    {name: "EMAIL",         visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,         function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
    {name: "PHONE",         visible: false,  enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,         function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
    {name: "CONTRACT",      visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "picklistText",      enableSelect: true,   columnSearch : false,   fromToFilter : false,   picklistTableName : "V_MS_CONTRACT_VL",function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
    {name: "COMPANY_MID",   visible: true,   enableFilter: true,  enableOrderBy: true,    export : false,   type : "picklistText",      enableSelect: true,   columnSearch : false,  fromToFilter : false,   picklistTableName : "V_MS_COMPANY_VL", function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
    {name: "CONTRACT_EXP",  visible: false,  enableFilter: true,  enableOrderBy: true,    export : false,   type : "text",          enableSelect: true,   columnSearch : true,   fromToFilter : false,   picklistTableName : null,         function : "Select",      CSSClass : null,         dateFromToFilter : [null, null],  dateMonthFilter : null,  orderByArrow : "",  fromToFilterValues : ["",""],  picklistSelectedItems : [],  picklistTable : [],  search : "", format : null,  defaultFilter: null},
  ]

  constructor(
    private shareData: SharingDataService,
    public dialogRef: MatDialogRef<personFwdDialog>,
    private formularService: FormularService,
    @Inject(MAT_DIALOG_DATA) public data
    ) {
      shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);

      if(data.email != null){
        let urls = [
          `admin/V_MS_USER?$filter=EMAIL eq '${data.email}' and ${this.defaultFilter}&$orderby=SURNAME asc`,
        ];
        this.formularService.getData(urls, (user) => {
          this.email = user[0][0].USERGUID;
          console.log(this.email)
          this.PersonIDGrid = this.PersonID;
        })
      } else {
        this.PersonIDGrid = this.PersonID;
      }
    }





    action(parameters){
      this[parameters.action](parameters.element, parameters.column, parameters.selectedSingleRows, parameters.selectedMultiRows);
    }

    Select(element, column, selectedSingleRows, selectedMultiRows){
      this.selectedRows = selectedSingleRows;
    }

    close(){
      this.dialogRef.close();
    }
  }
